import { rem } from 'polished';
import styled from 'styled-components';

export const LI = styled.li`
  position: relative;
  cursor: pointer;

  .practitioner-avatar {
    margin-bottom: ${rem(16)};

    .img-wrapper {
      img,
      svg {
        transition: transform 0.3s ease-in-out;
        transform: scale(1);
      }
    }
  }

  a {
    margin-bottom: ${rem(6)};
    font-size: ${rem(18)};
    color: inherit;
    display: block;
  }

  small {
    margin-bottom: ${rem(6)};
    font-size: ${rem(16)};
    font-weight: 400;
    text-transform: capitalize;
    display: block;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  li {
    font-size: ${rem(14)};
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 500;
    line-height: 140%;
    display: inline;

    &::before {
      content: ' · ';
    }

    &:first-child::before {
      display: none;
    }
  }

  &:hover,
  &:focus {
    .practitioner-avatar .img-wrapper {
      img,
      svg {
        transform: scale(1.1);
      }
    }
  }
`;
